module.exports = __webpack_public_path__ + "img/project-5.d40bf7dc.jpg";